import clickEventName from 'utils/DOM/clickEventName'
import { registerSnowplowTriggers } from 'utils/snowplow/events/userClick/registerSnowplowTriggers'

function registerSnowplowListeners() {
  const triggers = [
    {
      element: '#plan-card__details-control',
      description: 'Start Application - Learn more about this coverage',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-brochure',
      description: 'Start Application - View main brochure',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-add-on',
      description: 'Start Application - Dental checkbox',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-modal',
      description: 'Start Application - View Dental and Vision details',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#dental-actions',
      description: 'Start Application - Vision checkbox',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#dental-brochure',
      description: 'Start Application - View Dental and Vision brochure',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#find-dentist',
      description: 'Start Application - Find a dentist',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#vision-providers',
      description: 'Start Application - Vision providers',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-modal-latitude',
      description: 'Start Application - View Latitude details',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#latitude-brochure',
      description: 'Start Application - View Latitude brochure',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-latitude',
      description: 'Start Application - Latitude checkbox',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#extended-plan',
      description: 'Start Application - Add coverage',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.coverage-period__edit',
      description: 'Start Application - Edit coverage dates',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#sdate',
      description: 'Start Application - Edit start date',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#endDate',
      description: 'Start Application - Edit end date',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#period',
      description: 'Start Application - Edit period',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.coverage-period__save',
      description: 'Start Application - Save coverage changes',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-addon-delete',
      description: 'Start Application - Delete Dental addon',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '.js-latitude-delete',
      description: 'Start Application - Delete Latitude addon',
      elementTrigger: clickEventName,
      eventType: 'click'
    },
    {
      element: '#eligibility-link--sticky',
      description: 'Start Application - Continue to checkout',
      elementTrigger: clickEventName,
      eventType: 'click'
    }
  ]
  registerSnowplowTriggers(triggers)
}

export default registerSnowplowListeners
